import { render } from "./SidebarApp.vue?vue&type=template&id=8b34a512"
import script from "./SidebarApp.vue?vue&type=script&lang=js"
export * from "./SidebarApp.vue?vue&type=script&lang=js"

import "./SidebarApp.vue?vue&type=style&index=0&id=8b34a512&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__